export const blockIconsMapsLocalMallNew = (
	<span className='material-symbols-outlined'>local_mall</span>
);
